import jwt_decode from 'jwt-decode';

export const decodeJWT = (token: string) => {
  const decoded = jwt_decode<{ exp: number }>(token);
  return decoded;
};
